import angular from 'angular';
import BoxProductsComponent from './box-products.component';

let BoxProductsModule = angular.module('catalog.productsModules.boxProducts', [])
  .component('boxProducts', BoxProductsComponent);

export default BoxProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/box-products/box-products.js
 **/